import { Container } from '@components/Container'
import { Tabs } from '@components/Tabs/Tabs'
import { TabBody } from '@components/Tabs/components/TabBody'
import { MyWritingPageProps } from '@features/myWriting/pages/MyWritingPage/interface'
import { SearchForm } from '@features/myWriting/pages/MyWritingPage/components/SearchForm'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { UpgradeToWriter } from './components/UpgradeToWriter'
import { MutiSelectTable } from './components/MutiSelectTable'
import { SaleAnalyticsTab } from './components/SaleAnalyticsTab'
import { SettingPenName } from './components/SettingPenName'
import { MyEbookTab } from './components/MyEbookTab'

export function MyWriting({
  initialValues,
  page,
  perpage,
  total,
  myWritingList,
  isLoading,
  handlePaginationChange,
  perpageChange,
  handleSubmit,
  changeStatusGroup,
  changeStatus,
  handleTabChange,
}: MyWritingPageProps) {
  return (
    <Container className='desktop:!pt-[30px] tablet-mobile:px-[21px]'>
      <h1
        id='my-writing'
        className='font-mitr topic-base mb-[20px] mobile:mb-[10px] dark:text-primary'
      >
        จักรวาลนักเขียน
      </h1>
      <Tabs
        initialTabs={
          SHOW_EBOOK_FEATURE
            ? [
                { tabId: 'myWriting', name: 'งานเขียนของฉัน' },
                { tabId: 'myEbook', name: 'อีบุ๊กของฉัน' },
                { tabId: 'salesAnalytics', name: 'รายงานการขาย และแนวโน้ม' },
                { tabId: 'writer', name: 'ลงทะเบียนเพื่อรับรายได้' },
                { tabId: 'penName', name: 'จัดการนามปากกา' },
              ]
            : [
                { tabId: 'myWriting', name: 'งานเขียนของฉัน' },
                { tabId: 'salesAnalytics', name: 'รายงานการขาย และแนวโน้ม' },
                { tabId: 'writer', name: 'ลงทะเบียนเพื่อรับรายได้' },
                { tabId: 'penName', name: 'จัดการนามปากกา' },
              ]
        }
        onActiveTabChange={handleTabChange}
      >
        <TabBody tabId='myWriting'>
          <div className='grid gap-y-[20px]'>
            <hr className='w-full border-t border-gray-3 dark:border-purple desktop:hidden' />
            <SearchForm
              initialValues={initialValues}
              handleSubmit={handleSubmit}
            />
            <hr className='w-full border-t border-gray-3 dark:border-purple' />
          </div>
          <div className='mt-[20px] tablet:mt-[30px] mb-[60px]'>
            <MutiSelectTable
              data={myWritingList}
              page={page}
              perpage={perpage}
              total={total}
              loading={isLoading}
              pageChange={handlePaginationChange}
              perpageChange={perpageChange}
              changeStatusGroup={changeStatusGroup}
              changeStatus={changeStatus}
            />
          </div>
        </TabBody>
        {SHOW_EBOOK_FEATURE && (
          <TabBody tabId='myEbook'>
            <MyEbookTab />
          </TabBody>
        )}
        <TabBody tabId='salesAnalytics'>
          <SaleAnalyticsTab />
        </TabBody>
        <TabBody tabId='writer'>
          <UpgradeToWriter />
        </TabBody>
        <TabBody tabId='penName'>
          <SettingPenName />
        </TabBody>
      </Tabs>
    </Container>
  )
}
